var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"base-button-next",attrs:{"text":"","small":""}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_c('span',{staticClass:"mr-2"},[_vm._t("default")],2),_c('img',{staticStyle:{"transform":"rotate(900deg)"},attrs:{"src":_vm.svgSource,"alt":"next-button","onload":"SVGInject(this)"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }